import ReportsPageSelectReportView from './reports-page-select-report-view'

export default ReportsPageSelectReportView
